import {
  getImportTableOverrideStyle,
} from '@bingads-webui-campaign-react/imports-shared-styles';
import {
  convertToLocalStyle,
} from '@bingads-webui-campaign-react/common-styles';
import { getImportCalloutStyles } from './import-callout-styles';

export const getScheduleGridStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  ...convertToLocalStyle(getImportCalloutStyles({ palette })),
  '& table.table': {
    '& thead>tr>th, & tbody>tr>td': {
      '&:first-child': {
        borderRight: 'none !important',
      },

      '&:nth-child(2)': {
        borderLeft: 'none !important',
      },
    },

    '& colgroup': {
      '& .col-Name, & .col-CreatedBy': {
        width: '20%',
      },
    },
  },

  '& .statuschangesubtask': {
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: palette.neutralLight,
    },
    '& .statuschangelink': {
      padding: [5, 15],
      display: 'block',
      lineHeight: '1.5',

      '& .statuschange-icon': {
        marginRight: 5,
      },

      '& span': {
        verticalAlign: 'text-top',
      },
      '&>strong': {
        verticalAlign: 'text-bottom',
      },
    },
  },

  '& .statuschangehover:after': {
    color: palette.themeDark,
    content: '"\\E70D"',
    fontSize: 11,
    fontFamily: iconFontFamily,
    marginLeft: 5,
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
    opacity: 0,
  },

  '& table.table tbody>tr:hover .statuschangehover:after': {
    opacity: 1,
  },

  '& .import-schedule-accounts-detail': {
    paddingLeft: 3,
  },
  '& .edit-task': {
    color: palette.themePrimary,
  },
  '& .insight_icon': {
    color: palette.themePrimary,
    paddingRight: '3px',
  },


  '& .statusDeleted_icon': {
    color: 'red',
  },

  '& .col-Name p': {
    wordBreak: 'break-word',
  },
});

export const getGoogleAdsAccountViewStyle = ({ palette = {} }) => ({
  '.GoogleAdsAccountView': {
    padding: [10, 20],

    '& .popover-view__content': {
      padding: [21, 0, 10, 0],
    },

    ...getImportTableOverrideStyle({ palette }),
  },
});
